"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "11 1 11 6 16 6 11 1",
    style: {
      fill: 'none'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17,10V5.5a.5.5,0,0,0-.15-.35l-5-5A.5.5,0,0,0,11.5,0H.5A.5.5,0,0,0,0,.5v21a.5.5,0,0,0,.5.5h11A7.48,7.48,0,0,1,17,10ZM11,1l5,5H11Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.5,24A6.5,6.5,0,1,0,11,17.5,6.5,6.5,0,0,0,17.5,24ZM15,16.29l2.15-2.15a.5.5,0,0,1,.71,0L20,16.29a.5.5,0,0,1-.71.71L18,15.71V20.5a.5.5,0,1,1-1, 0V15.71L15.71,17a.5.5,0,0,1-.71-.71Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.8,7.72H1.17a.38.38,0,0,1,0-.75H12.8a.38.38,0,0,1,0,.75Z",
    style: {
      fill: '#fff'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.8,10H1.17a.38.38,0,0,1,0-.75H12.8a.38.38,0,0,1,0,.75Z",
    style: {
      fill: '#fff'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.27,12.28H1.17a.37.37,0,0,1,0-.75h9.09a.38.38,0,0,1,0,.75Z",
    style: {
      fill: '#fff'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.18,14.56h-7a.38.38,0,0,1,0-.75h7a.38.38,0,0,1,0,.75Z",
    style: {
      fill: '#fff'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.18,16.84h-7a.38.38,0,0,1,0-.75h7a.38.38,0,0,1,0,.75Z",
    style: {
      fill: '#fff'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.18,19.13h-7a.37.37,0,0,1,0-.75h7a.38.38,0,0,1,0,.75Z",
    style: {
      fill: '#fff'
    }
  }));
};

exports["default"] = _default;